export enum LanguageEnum {
  EN_GB = 'en-GB',
  EN_US = 'en-US',
  BG_BG = 'bg-BG',
  FIL_PH = 'fil-PH',
  NL_NL = 'nl-NL'
}
